import type { ReactNode } from 'react';
import { cn } from '../../common/functions/cn';

interface ErrorLabelProps {
  children: ReactNode;
  className?: string;
  /** Set when the invalid control references this message with `aria-describedby`. */
  id?: string;
  role?: string;
}

export default function ErrorLabel({ children, className, id, role = 'alert' }: ErrorLabelProps) {
  const errorLabelClasses = cn('mt-1 text-xs text-error', className);
  return (
    <span className={errorLabelClasses} id={id} role={role}>
      {children}
    </span>
  );
}
